// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/reaper.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Timestamp } from "../util/util";

export const protobufPackage = "carbon.portal.reaper";

export interface ModuleIdentity {
  id: number;
  serial: string;
}

export interface ModuleDefinition {
  moduleId: number;
  /** left edge to left edge distance from the */
  moduleSpacingMm: number;
  /**
   * module to its left to this one. 0 for the
   * first module in a row
   */
  disabled: boolean;
}

export interface RowDefinition {
  rowId: number;
  modules: ModuleDefinition[];
  /** left edge to left edge distance from the last */
  rowSpacingMm: number;
}

export interface BarDefinition {
  barLengthMm: number;
  folding: boolean;
}

export interface RobotDefinition {
  rows: RowDefinition[];
  barDefinition: BarDefinition | undefined;
}

export interface ReaperConfiguration {
  assignedModules: ModuleIdentity[];
  currentRobotDefinition: RobotDefinition | undefined;
}

export interface UploadReaperConfigurationRequest {
  configuration: ReaperConfiguration | undefined;
}

export interface UploadReaperConfigurationResponse {
}

export interface ModuleAssignment {
  id: number;
  serial: string;
  updatedAt: Timestamp | undefined;
}

export interface ModuleList {
  modules: ModuleAssignment[];
}

export interface AssignedModulesResponse {
  robotIdToModules: { [key: number]: ModuleList };
}

export interface AssignedModulesResponse_RobotIdToModulesEntry {
  key: number;
  value: ModuleList | undefined;
}

export interface ReaperModulePeriod {
  rowId: number;
  moduleId: number;
  serial: string;
  disabled: boolean;
  startDate:
    | Timestamp
    | undefined;
  /** not set if currently active */
  endDate: Timestamp | undefined;
}

export interface ReaperModuleHistoryResponse {
  periods: ReaperModulePeriod[];
}

function createBaseModuleIdentity(): ModuleIdentity {
  return { id: 0, serial: "" };
}

export const ModuleIdentity: MessageFns<ModuleIdentity> = {
  encode(message: ModuleIdentity, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.serial !== "") {
      writer.uint32(18).string(message.serial);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModuleIdentity {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleIdentity();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModuleIdentity {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
    };
  },

  toJSON(message: ModuleIdentity): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModuleIdentity>, I>>(base?: I): ModuleIdentity {
    return ModuleIdentity.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModuleIdentity>, I>>(object: I): ModuleIdentity {
    const message = createBaseModuleIdentity();
    message.id = object.id ?? 0;
    message.serial = object.serial ?? "";
    return message;
  },
};

function createBaseModuleDefinition(): ModuleDefinition {
  return { moduleId: 0, moduleSpacingMm: 0, disabled: false };
}

export const ModuleDefinition: MessageFns<ModuleDefinition> = {
  encode(message: ModuleDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.moduleId !== 0) {
      writer.uint32(8).uint32(message.moduleId);
    }
    if (message.moduleSpacingMm !== 0) {
      writer.uint32(21).float(message.moduleSpacingMm);
    }
    if (message.disabled !== false) {
      writer.uint32(24).bool(message.disabled);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModuleDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.moduleId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 21) {
            break;
          }

          message.moduleSpacingMm = reader.float();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModuleDefinition {
    return {
      moduleId: isSet(object.moduleId)
        ? globalThis.Number(object.moduleId)
        : isSet(object.module_id)
        ? globalThis.Number(object.module_id)
        : 0,
      moduleSpacingMm: isSet(object.moduleSpacingMm)
        ? globalThis.Number(object.moduleSpacingMm)
        : isSet(object.module_spacing_mm)
        ? globalThis.Number(object.module_spacing_mm)
        : 0,
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
    };
  },

  toJSON(message: ModuleDefinition): unknown {
    const obj: any = {};
    if (message.moduleId !== 0) {
      obj.moduleId = Math.round(message.moduleId);
    }
    if (message.moduleSpacingMm !== 0) {
      obj.moduleSpacingMm = message.moduleSpacingMm;
    }
    if (message.disabled !== false) {
      obj.disabled = message.disabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModuleDefinition>, I>>(base?: I): ModuleDefinition {
    return ModuleDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModuleDefinition>, I>>(object: I): ModuleDefinition {
    const message = createBaseModuleDefinition();
    message.moduleId = object.moduleId ?? 0;
    message.moduleSpacingMm = object.moduleSpacingMm ?? 0;
    message.disabled = object.disabled ?? false;
    return message;
  },
};

function createBaseRowDefinition(): RowDefinition {
  return { rowId: 0, modules: [], rowSpacingMm: 0 };
}

export const RowDefinition: MessageFns<RowDefinition> = {
  encode(message: RowDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rowId !== 0) {
      writer.uint32(8).uint32(message.rowId);
    }
    for (const v of message.modules) {
      ModuleDefinition.encode(v!, writer.uint32(18).fork()).join();
    }
    if (message.rowSpacingMm !== 0) {
      writer.uint32(29).float(message.rowSpacingMm);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RowDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRowDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rowId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.modules.push(ModuleDefinition.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 29) {
            break;
          }

          message.rowSpacingMm = reader.float();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RowDefinition {
    return {
      rowId: isSet(object.rowId)
        ? globalThis.Number(object.rowId)
        : isSet(object.row_id)
        ? globalThis.Number(object.row_id)
        : 0,
      modules: globalThis.Array.isArray(object?.modules)
        ? object.modules.map((e: any) => ModuleDefinition.fromJSON(e))
        : [],
      rowSpacingMm: isSet(object.rowSpacingMm)
        ? globalThis.Number(object.rowSpacingMm)
        : isSet(object.row_spacing_mm)
        ? globalThis.Number(object.row_spacing_mm)
        : 0,
    };
  },

  toJSON(message: RowDefinition): unknown {
    const obj: any = {};
    if (message.rowId !== 0) {
      obj.rowId = Math.round(message.rowId);
    }
    if (message.modules?.length) {
      obj.modules = message.modules.map((e) => ModuleDefinition.toJSON(e));
    }
    if (message.rowSpacingMm !== 0) {
      obj.rowSpacingMm = message.rowSpacingMm;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RowDefinition>, I>>(base?: I): RowDefinition {
    return RowDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RowDefinition>, I>>(object: I): RowDefinition {
    const message = createBaseRowDefinition();
    message.rowId = object.rowId ?? 0;
    message.modules = object.modules?.map((e) => ModuleDefinition.fromPartial(e)) || [];
    message.rowSpacingMm = object.rowSpacingMm ?? 0;
    return message;
  },
};

function createBaseBarDefinition(): BarDefinition {
  return { barLengthMm: 0, folding: false };
}

export const BarDefinition: MessageFns<BarDefinition> = {
  encode(message: BarDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.barLengthMm !== 0) {
      writer.uint32(8).uint32(message.barLengthMm);
    }
    if (message.folding !== false) {
      writer.uint32(16).bool(message.folding);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): BarDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseBarDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.barLengthMm = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.folding = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): BarDefinition {
    return {
      barLengthMm: isSet(object.barLengthMm)
        ? globalThis.Number(object.barLengthMm)
        : isSet(object.bar_length_mm)
        ? globalThis.Number(object.bar_length_mm)
        : 0,
      folding: isSet(object.folding) ? globalThis.Boolean(object.folding) : false,
    };
  },

  toJSON(message: BarDefinition): unknown {
    const obj: any = {};
    if (message.barLengthMm !== 0) {
      obj.barLengthMm = Math.round(message.barLengthMm);
    }
    if (message.folding !== false) {
      obj.folding = message.folding;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<BarDefinition>, I>>(base?: I): BarDefinition {
    return BarDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<BarDefinition>, I>>(object: I): BarDefinition {
    const message = createBaseBarDefinition();
    message.barLengthMm = object.barLengthMm ?? 0;
    message.folding = object.folding ?? false;
    return message;
  },
};

function createBaseRobotDefinition(): RobotDefinition {
  return { rows: [], barDefinition: undefined };
}

export const RobotDefinition: MessageFns<RobotDefinition> = {
  encode(message: RobotDefinition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rows) {
      RowDefinition.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.barDefinition !== undefined) {
      BarDefinition.encode(message.barDefinition, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RobotDefinition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRobotDefinition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rows.push(RowDefinition.decode(reader, reader.uint32()));
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.barDefinition = BarDefinition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RobotDefinition {
    return {
      rows: globalThis.Array.isArray(object?.rows) ? object.rows.map((e: any) => RowDefinition.fromJSON(e)) : [],
      barDefinition: isSet(object.barDefinition)
        ? BarDefinition.fromJSON(object.barDefinition)
        : isSet(object.bar_definition)
        ? BarDefinition.fromJSON(object.bar_definition)
        : undefined,
    };
  },

  toJSON(message: RobotDefinition): unknown {
    const obj: any = {};
    if (message.rows?.length) {
      obj.rows = message.rows.map((e) => RowDefinition.toJSON(e));
    }
    if (message.barDefinition !== undefined) {
      obj.barDefinition = BarDefinition.toJSON(message.barDefinition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RobotDefinition>, I>>(base?: I): RobotDefinition {
    return RobotDefinition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RobotDefinition>, I>>(object: I): RobotDefinition {
    const message = createBaseRobotDefinition();
    message.rows = object.rows?.map((e) => RowDefinition.fromPartial(e)) || [];
    message.barDefinition = (object.barDefinition !== undefined && object.barDefinition !== null)
      ? BarDefinition.fromPartial(object.barDefinition)
      : undefined;
    return message;
  },
};

function createBaseReaperConfiguration(): ReaperConfiguration {
  return { assignedModules: [], currentRobotDefinition: undefined };
}

export const ReaperConfiguration: MessageFns<ReaperConfiguration> = {
  encode(message: ReaperConfiguration, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.assignedModules) {
      ModuleIdentity.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.currentRobotDefinition !== undefined) {
      RobotDefinition.encode(message.currentRobotDefinition, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReaperConfiguration {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReaperConfiguration();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.assignedModules.push(ModuleIdentity.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.currentRobotDefinition = RobotDefinition.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReaperConfiguration {
    return {
      assignedModules: globalThis.Array.isArray(object?.assignedModules)
        ? object.assignedModules.map((e: any) => ModuleIdentity.fromJSON(e))
        : globalThis.Array.isArray(object?.assigned_modules)
        ? object.assigned_modules.map((e: any) => ModuleIdentity.fromJSON(e))
        : [],
      currentRobotDefinition: isSet(object.currentRobotDefinition)
        ? RobotDefinition.fromJSON(object.currentRobotDefinition)
        : isSet(object.current_robot_definition)
        ? RobotDefinition.fromJSON(object.current_robot_definition)
        : undefined,
    };
  },

  toJSON(message: ReaperConfiguration): unknown {
    const obj: any = {};
    if (message.assignedModules?.length) {
      obj.assignedModules = message.assignedModules.map((e) => ModuleIdentity.toJSON(e));
    }
    if (message.currentRobotDefinition !== undefined) {
      obj.currentRobotDefinition = RobotDefinition.toJSON(message.currentRobotDefinition);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReaperConfiguration>, I>>(base?: I): ReaperConfiguration {
    return ReaperConfiguration.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReaperConfiguration>, I>>(object: I): ReaperConfiguration {
    const message = createBaseReaperConfiguration();
    message.assignedModules = object.assignedModules?.map((e) => ModuleIdentity.fromPartial(e)) || [];
    message.currentRobotDefinition =
      (object.currentRobotDefinition !== undefined && object.currentRobotDefinition !== null)
        ? RobotDefinition.fromPartial(object.currentRobotDefinition)
        : undefined;
    return message;
  },
};

function createBaseUploadReaperConfigurationRequest(): UploadReaperConfigurationRequest {
  return { configuration: undefined };
}

export const UploadReaperConfigurationRequest: MessageFns<UploadReaperConfigurationRequest> = {
  encode(message: UploadReaperConfigurationRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.configuration !== undefined) {
      ReaperConfiguration.encode(message.configuration, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadReaperConfigurationRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadReaperConfigurationRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.configuration = ReaperConfiguration.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UploadReaperConfigurationRequest {
    return {
      configuration: isSet(object.configuration) ? ReaperConfiguration.fromJSON(object.configuration) : undefined,
    };
  },

  toJSON(message: UploadReaperConfigurationRequest): unknown {
    const obj: any = {};
    if (message.configuration !== undefined) {
      obj.configuration = ReaperConfiguration.toJSON(message.configuration);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadReaperConfigurationRequest>, I>>(
    base?: I,
  ): UploadReaperConfigurationRequest {
    return UploadReaperConfigurationRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadReaperConfigurationRequest>, I>>(
    object: I,
  ): UploadReaperConfigurationRequest {
    const message = createBaseUploadReaperConfigurationRequest();
    message.configuration = (object.configuration !== undefined && object.configuration !== null)
      ? ReaperConfiguration.fromPartial(object.configuration)
      : undefined;
    return message;
  },
};

function createBaseUploadReaperConfigurationResponse(): UploadReaperConfigurationResponse {
  return {};
}

export const UploadReaperConfigurationResponse: MessageFns<UploadReaperConfigurationResponse> = {
  encode(_: UploadReaperConfigurationResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UploadReaperConfigurationResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUploadReaperConfigurationResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UploadReaperConfigurationResponse {
    return {};
  },

  toJSON(_: UploadReaperConfigurationResponse): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UploadReaperConfigurationResponse>, I>>(
    base?: I,
  ): UploadReaperConfigurationResponse {
    return UploadReaperConfigurationResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UploadReaperConfigurationResponse>, I>>(
    _: I,
  ): UploadReaperConfigurationResponse {
    const message = createBaseUploadReaperConfigurationResponse();
    return message;
  },
};

function createBaseModuleAssignment(): ModuleAssignment {
  return { id: 0, serial: "", updatedAt: undefined };
}

export const ModuleAssignment: MessageFns<ModuleAssignment> = {
  encode(message: ModuleAssignment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== 0) {
      writer.uint32(8).uint32(message.id);
    }
    if (message.serial !== "") {
      writer.uint32(18).string(message.serial);
    }
    if (message.updatedAt !== undefined) {
      Timestamp.encode(message.updatedAt, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModuleAssignment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleAssignment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.id = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.updatedAt = Timestamp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModuleAssignment {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      updatedAt: isSet(object.updatedAt)
        ? Timestamp.fromJSON(object.updatedAt)
        : isSet(object.updated_at)
        ? Timestamp.fromJSON(object.updated_at)
        : undefined,
    };
  },

  toJSON(message: ModuleAssignment): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.updatedAt !== undefined) {
      obj.updatedAt = Timestamp.toJSON(message.updatedAt);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModuleAssignment>, I>>(base?: I): ModuleAssignment {
    return ModuleAssignment.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModuleAssignment>, I>>(object: I): ModuleAssignment {
    const message = createBaseModuleAssignment();
    message.id = object.id ?? 0;
    message.serial = object.serial ?? "";
    message.updatedAt = (object.updatedAt !== undefined && object.updatedAt !== null)
      ? Timestamp.fromPartial(object.updatedAt)
      : undefined;
    return message;
  },
};

function createBaseModuleList(): ModuleList {
  return { modules: [] };
}

export const ModuleList: MessageFns<ModuleList> = {
  encode(message: ModuleList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.modules) {
      ModuleAssignment.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ModuleList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseModuleList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.modules.push(ModuleAssignment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ModuleList {
    return {
      modules: globalThis.Array.isArray(object?.modules)
        ? object.modules.map((e: any) => ModuleAssignment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ModuleList): unknown {
    const obj: any = {};
    if (message.modules?.length) {
      obj.modules = message.modules.map((e) => ModuleAssignment.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ModuleList>, I>>(base?: I): ModuleList {
    return ModuleList.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ModuleList>, I>>(object: I): ModuleList {
    const message = createBaseModuleList();
    message.modules = object.modules?.map((e) => ModuleAssignment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseAssignedModulesResponse(): AssignedModulesResponse {
  return { robotIdToModules: {} };
}

export const AssignedModulesResponse: MessageFns<AssignedModulesResponse> = {
  encode(message: AssignedModulesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.robotIdToModules).forEach(([key, value]: [string, ModuleList]) => {
      AssignedModulesResponse_RobotIdToModulesEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AssignedModulesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAssignedModulesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = AssignedModulesResponse_RobotIdToModulesEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.robotIdToModules[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AssignedModulesResponse {
    return {
      robotIdToModules: isObject(object.robotIdToModules)
        ? (globalThis.Object.entries(object.robotIdToModules) as [string, any][]).reduce(
          (acc: { [key: number]: ModuleList }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = ModuleList.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.robot_id_to_modules)
        ? (globalThis.Object.entries(object.robot_id_to_modules) as [string, any][]).reduce(
          (acc: { [key: number]: ModuleList }, [key, value]: [string, any]) => {
            acc[globalThis.Number(key)] = ModuleList.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: AssignedModulesResponse): unknown {
    const obj: any = {};
    if (message.robotIdToModules) {
      const entries = globalThis.Object.entries(message.robotIdToModules) as [string, ModuleList][];
      if (entries.length > 0) {
        obj.robotIdToModules = {};
        entries.forEach(([k, v]) => {
          obj.robotIdToModules[k] = ModuleList.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AssignedModulesResponse>, I>>(base?: I): AssignedModulesResponse {
    return AssignedModulesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AssignedModulesResponse>, I>>(object: I): AssignedModulesResponse {
    const message = createBaseAssignedModulesResponse();
    message.robotIdToModules = (globalThis.Object.entries(object.robotIdToModules ?? {}) as [string, ModuleList][])
      .reduce((acc: { [key: number]: ModuleList }, [key, value]: [string, ModuleList]) => {
        if (value !== undefined) {
          acc[globalThis.Number(key)] = ModuleList.fromPartial(value);
        }
        return acc;
      }, {});
    return message;
  },
};

function createBaseAssignedModulesResponse_RobotIdToModulesEntry(): AssignedModulesResponse_RobotIdToModulesEntry {
  return { key: 0, value: undefined };
}

export const AssignedModulesResponse_RobotIdToModulesEntry: MessageFns<AssignedModulesResponse_RobotIdToModulesEntry> =
  {
    encode(
      message: AssignedModulesResponse_RobotIdToModulesEntry,
      writer: BinaryWriter = new BinaryWriter(),
    ): BinaryWriter {
      if (message.key !== 0) {
        writer.uint32(8).uint64(message.key);
      }
      if (message.value !== undefined) {
        ModuleList.encode(message.value, writer.uint32(18).fork()).join();
      }
      return writer;
    },

    decode(input: BinaryReader | Uint8Array, length?: number): AssignedModulesResponse_RobotIdToModulesEntry {
      const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
      const end = length === undefined ? reader.len : reader.pos + length;
      const message = createBaseAssignedModulesResponse_RobotIdToModulesEntry();
      while (reader.pos < end) {
        const tag = reader.uint32();
        switch (tag >>> 3) {
          case 1: {
            if (tag !== 8) {
              break;
            }

            message.key = longToNumber(reader.uint64());
            continue;
          }
          case 2: {
            if (tag !== 18) {
              break;
            }

            message.value = ModuleList.decode(reader, reader.uint32());
            continue;
          }
        }
        if ((tag & 7) === 4 || tag === 0) {
          break;
        }
        reader.skip(tag & 7);
      }
      return message;
    },

    fromJSON(object: any): AssignedModulesResponse_RobotIdToModulesEntry {
      return {
        key: isSet(object.key) ? globalThis.Number(object.key) : 0,
        value: isSet(object.value) ? ModuleList.fromJSON(object.value) : undefined,
      };
    },

    toJSON(message: AssignedModulesResponse_RobotIdToModulesEntry): unknown {
      const obj: any = {};
      if (message.key !== 0) {
        obj.key = Math.round(message.key);
      }
      if (message.value !== undefined) {
        obj.value = ModuleList.toJSON(message.value);
      }
      return obj;
    },

    create<I extends Exact<DeepPartial<AssignedModulesResponse_RobotIdToModulesEntry>, I>>(
      base?: I,
    ): AssignedModulesResponse_RobotIdToModulesEntry {
      return AssignedModulesResponse_RobotIdToModulesEntry.fromPartial(base ?? ({} as any));
    },
    fromPartial<I extends Exact<DeepPartial<AssignedModulesResponse_RobotIdToModulesEntry>, I>>(
      object: I,
    ): AssignedModulesResponse_RobotIdToModulesEntry {
      const message = createBaseAssignedModulesResponse_RobotIdToModulesEntry();
      message.key = object.key ?? 0;
      message.value = (object.value !== undefined && object.value !== null)
        ? ModuleList.fromPartial(object.value)
        : undefined;
      return message;
    },
  };

function createBaseReaperModulePeriod(): ReaperModulePeriod {
  return { rowId: 0, moduleId: 0, serial: "", disabled: false, startDate: undefined, endDate: undefined };
}

export const ReaperModulePeriod: MessageFns<ReaperModulePeriod> = {
  encode(message: ReaperModulePeriod, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rowId !== 0) {
      writer.uint32(8).uint32(message.rowId);
    }
    if (message.moduleId !== 0) {
      writer.uint32(16).uint32(message.moduleId);
    }
    if (message.serial !== "") {
      writer.uint32(26).string(message.serial);
    }
    if (message.disabled !== false) {
      writer.uint32(32).bool(message.disabled);
    }
    if (message.startDate !== undefined) {
      Timestamp.encode(message.startDate, writer.uint32(42).fork()).join();
    }
    if (message.endDate !== undefined) {
      Timestamp.encode(message.endDate, writer.uint32(50).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReaperModulePeriod {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReaperModulePeriod();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.rowId = reader.uint32();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.moduleId = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.disabled = reader.bool();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.startDate = Timestamp.decode(reader, reader.uint32());
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.endDate = Timestamp.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReaperModulePeriod {
    return {
      rowId: isSet(object.rowId)
        ? globalThis.Number(object.rowId)
        : isSet(object.row_id)
        ? globalThis.Number(object.row_id)
        : 0,
      moduleId: isSet(object.moduleId)
        ? globalThis.Number(object.moduleId)
        : isSet(object.module_id)
        ? globalThis.Number(object.module_id)
        : 0,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : "",
      disabled: isSet(object.disabled) ? globalThis.Boolean(object.disabled) : false,
      startDate: isSet(object.startDate)
        ? Timestamp.fromJSON(object.startDate)
        : isSet(object.start_date)
        ? Timestamp.fromJSON(object.start_date)
        : undefined,
      endDate: isSet(object.endDate)
        ? Timestamp.fromJSON(object.endDate)
        : isSet(object.end_date)
        ? Timestamp.fromJSON(object.end_date)
        : undefined,
    };
  },

  toJSON(message: ReaperModulePeriod): unknown {
    const obj: any = {};
    if (message.rowId !== 0) {
      obj.rowId = Math.round(message.rowId);
    }
    if (message.moduleId !== 0) {
      obj.moduleId = Math.round(message.moduleId);
    }
    if (message.serial !== "") {
      obj.serial = message.serial;
    }
    if (message.disabled !== false) {
      obj.disabled = message.disabled;
    }
    if (message.startDate !== undefined) {
      obj.startDate = Timestamp.toJSON(message.startDate);
    }
    if (message.endDate !== undefined) {
      obj.endDate = Timestamp.toJSON(message.endDate);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReaperModulePeriod>, I>>(base?: I): ReaperModulePeriod {
    return ReaperModulePeriod.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReaperModulePeriod>, I>>(object: I): ReaperModulePeriod {
    const message = createBaseReaperModulePeriod();
    message.rowId = object.rowId ?? 0;
    message.moduleId = object.moduleId ?? 0;
    message.serial = object.serial ?? "";
    message.disabled = object.disabled ?? false;
    message.startDate = (object.startDate !== undefined && object.startDate !== null)
      ? Timestamp.fromPartial(object.startDate)
      : undefined;
    message.endDate = (object.endDate !== undefined && object.endDate !== null)
      ? Timestamp.fromPartial(object.endDate)
      : undefined;
    return message;
  },
};

function createBaseReaperModuleHistoryResponse(): ReaperModuleHistoryResponse {
  return { periods: [] };
}

export const ReaperModuleHistoryResponse: MessageFns<ReaperModuleHistoryResponse> = {
  encode(message: ReaperModuleHistoryResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.periods) {
      ReaperModulePeriod.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ReaperModuleHistoryResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseReaperModuleHistoryResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.periods.push(ReaperModulePeriod.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ReaperModuleHistoryResponse {
    return {
      periods: globalThis.Array.isArray(object?.periods)
        ? object.periods.map((e: any) => ReaperModulePeriod.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ReaperModuleHistoryResponse): unknown {
    const obj: any = {};
    if (message.periods?.length) {
      obj.periods = message.periods.map((e) => ReaperModulePeriod.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ReaperModuleHistoryResponse>, I>>(base?: I): ReaperModuleHistoryResponse {
    return ReaperModuleHistoryResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ReaperModuleHistoryResponse>, I>>(object: I): ReaperModuleHistoryResponse {
    const message = createBaseReaperModuleHistoryResponse();
    message.periods = object.periods?.map((e) => ReaperModulePeriod.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
